import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { getQueryParams } from 'shared/utils/helpers'
import appConfig from 'app.config'
import './idCardContentBlock.scss'
import TermsAndConditionBlock from 'auth/constants/termsAndConditions/termsAndConditionsBlock'
import { AuthContext } from 'shared'

function IdCardContentBlock() {
	const { t } = useTranslation()
	const { setLoadingAuth } = useContext(AuthContext)

	async function tryIdCardAuth() {
		setLoadingAuth(true)
		let { ReturnUrl, SigningRequestId } = getQueryParams()

		const action = encodeURIComponent(
			`${appConfig.authorityBaseUrl}/apiauth/idcard/${
				SigningRequestId || ''
			}`,
		)

		const returnUrl = encodeURIComponent(
			ReturnUrl ||
				`${window.location.protocol}//${window.location.hostname}/callback`,
		)

		window.location.replace(
			`${appConfig.certificateRequesterBaseUrl}?returnUrl=${returnUrl}&action=${action}`,
		)
		setLoadingAuth(false)
	}

	return (
		<div className="id-card-container">
			<div className="login-description">
				<p>{t('IdCardLine1')}</p>
				<p>
					{t('IdCardLine2')}{' '}
					<a
						target="_blank"
						rel="noopener noreferrer"
						href="http://www.id.ee/?lang=en&id=30466">
						{t('IdCardLine3')}.
					</a>
				</p>
			</div>

			<button onClick={tryIdCardAuth} className="btn btn-primary mt-4">
				{t('Proceed')}
			</button>
			<TermsAndConditionBlock className="mt-4" />
		</div>
	)
}

export default IdCardContentBlock
